import React from 'react';

// SVG Inline
import SVG from 'react-inlinesvg';

import DeleteSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/Lixeira.svg';
import EditSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/Editar.svg';
import CommentsSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/Resposta.svg';
import PaintSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/Pintar.svg';
import CloseSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/X.svg';
import SaveSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/Salvar.svg';
import TableSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/Tabela.svg';
import OKSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/OK.svg';
import BlockSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/Bloquear.svg';
import CopySrc from 'assets/images/icons/DesignSysten2.0/tools_interface/Copiar.svg';
import VisibilityOnSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/Visibilidade ON.svg';
import VisibilityOffSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/Visibilidade OFF.svg';
import HomeSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/Homepage.svg';
import SetingsSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/Configurações.svg';
import ReportSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/Prancheta.svg';
import CalendarSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/Calendário.svg';
import WatchSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/Relógio 4.svg';
import ApproveSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/aprovar.svg';
import DisapproveSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/reprovar.svg';
import InaccuracySrc from 'assets/images/icons/DesignSysten2.0/tools_interface/imprecisão.svg';
import HistorySrc from 'assets/images/icons/DesignSysten2.0/tools_interface/Histórico.svg';
import OpenPadlockSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/OpenPadlock.svg';
import ClosePadlockSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/ClosePadlock.svg';
import ZoomPlusSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/Zoom +.svg';
import TransferSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/transfer.svg';
import CancelSrc from 'assets/images/icons/DesignSysten2.0/tools_interface/cancel.svg';

interface SVGInlineInterface {
  width?: number | string;
  height?: number | string;
  fill?: string;
}
export const Block: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={BlockSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Transfer: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={TransferSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const OK: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={OKSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const Copy: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={CopySrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Delete: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={DeleteSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Edit: React.FC<SVGInlineInterface> = ({ width, height, fill }) => (
  <SVG
    src={EditSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Comments: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={CommentsSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Paint: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={PaintSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const Close: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={CloseSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Save: React.FC<SVGInlineInterface> = ({ width, height, fill }) => (
  <SVG
    src={SaveSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Table: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={TableSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const VisibilityOn: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={VisibilityOnSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const VisibilityOff: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={VisibilityOffSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Home: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={HomeSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Setings: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={SetingsSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Report: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={ReportSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const Calendar: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={CalendarSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Cancel: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={CancelSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Watch: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={WatchSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Approve: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
}) => (
  <SVG
    src={ApproveSrc}
    style={{ width, height }}
    cacheRequests
    title='Aprovado'
  />
);

export const Disapprove: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
}) => (
  <SVG
    src={DisapproveSrc}
    style={{ width, height }}
    cacheRequests
    title='Rprovado'
  />
);

export const Inaccuracy: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
}) => (
  <SVG
    src={InaccuracySrc}
    style={{ width, height }}
    cacheRequests
    title='Imprecisão'
  />
);
export const OpenPadlock: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
}) => <SVG src={OpenPadlockSrc} style={{ width, height }} cacheRequests />;

export const ClosePadlock: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
}) => <SVG src={ClosePadlockSrc} style={{ width, height }} cacheRequests />;

export const History: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
}) => (
  <SVG
    src={HistorySrc}
    style={{ width, height }}
    cacheRequests
    title='Imprecisão'
  />
);

export const ZoomPlus: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
}) => <SVG src={ZoomPlusSrc} style={{ width, height }} cacheRequests />;
